import type { BooleanRecord } from "@p-ban/common/src/types"

import ESTIMATE_CONSTANT from "../constant/estimateConstant"
import type EstimateValues from "../types/params"

const getDisabledCondition = (values: EstimateValues): BooleanRecord<EstimateValues> => {
  const record = {} as BooleanRecord<EstimateValues>
  ;(Object.keys(values) as (keyof EstimateValues)[]).forEach((key) => {
    record[key] = false
  })

  return {
    ...record,
    sideOfSmd: (values.pieceCnt ?? 0) <= 0 && (values.bgacsp ?? 0) <= 0,
    sideOfDip: (values.dipPartCnt ?? 0) <= 0,
    resistColor: values.resistPrint === ESTIMATE_CONSTANT.塗布する面.塗らない.value,
    coverLay: values.coverLaySide === ESTIMATE_CONSTANT.貼る面.貼らない.value,
    coverLayColor:
      values.coverLaySide === ESTIMATE_CONSTANT.貼る面.貼らない.value ||
      values.coverLay === ESTIMATE_CONSTANT.カバーレイ.グリーンレジスト.value,
    silkColor: values.silk === ESTIMATE_CONSTANT.印刷する面.なし.value,
    silkPrintMethod: values.silk === ESTIMATE_CONSTANT.印刷する面.なし.value,
    panelizedItemKindCnt: values.panelizedItemCnt === 1,
    routerCutKind: values.routerCut === ESTIMATE_CONSTANT["ルーター切り出し面付け 面付け数"]["なし"].value,
    rouletteKind: values.roulette === ESTIMATE_CONSTANT["ミシン目面付け 面付け数"]["なし"].value,
  }
}

export default getDisabledCondition
